import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";

export const AboutUs = () => {
  const { t } = useLang();
  const a = t.aboutUs;

  return (
    <section
      id="about-us"
      className="relative overflow-hidden bg-sand py-24 sm:py-32"
      data-testid="about-us-section"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-16">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="relative overflow-hidden rounded-[2rem] rounded-br-none shadow-2xl">
              <img
                src={IMAGES.casaSunset}
                alt="Sunset over the bay with fishing boats in San Juan del Sur, Nicaragua"
                className="aspect-[3/4] w-full object-cover"
                loading="lazy"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-purpleink-deep/30 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 rounded-full bg-white/90 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-purpleink shadow-lg backdrop-blur">
                Familia · San Juan del Sur
              </div>
            </div>
          </motion.div>

          {/* Text */}
          <div className="lg:col-span-6 lg:col-start-7">
            <span className="text-xs font-medium uppercase tracking-[0.3em] text-teal" data-testid="about-us-kicker">
              {a.kicker}
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-purpleink-deep sm:text-5xl"
              data-testid="about-us-title"
            >
              {a.title}
            </motion.h2>

            <div className="mt-8 space-y-5">
              {a.body.map((para, i) => (
                <motion.p
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className="text-base leading-relaxed text-stone-600 sm:text-[1.05rem]"
                  data-testid={`about-us-para-${i}`}
                >
                  {para}
                </motion.p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
